import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import PaxCalculator from "@/components/PaxCalculator";
import { ArrowRight, ShieldCheck, MapPin } from "lucide-react";

const CITY = {
  koebenhavn: {
    da: { name: "København", title: "Møbelmontering i København", desc: "Professionel montering af IKEA-møbler i hele Storkøbenhavn — PAX, senge, reoler og køkkener. Fast pris inkl. moms.", area: "1000–2990 København" },
    en: { name: "Copenhagen", title: "Furniture assembly in Copenhagen", desc: "Professional IKEA furniture assembly across Greater Copenhagen — PAX, beds, shelving and kitchens. Fixed price incl. VAT.", area: "1000–2990 Copenhagen" },
  },
  nordsjaelland: {
    da: { name: "Nordsjælland", title: "Møbelmontering i Nordsjælland", desc: "Vi samler dine IKEA-møbler i Nordsjælland — Hillerød, Helsingør, Hørsholm og omegn. Fast pris inkl. moms.", area: "3000–3670 Nordsjælland" },
    en: { name: "North Zealand", title: "Furniture assembly in North Zealand", desc: "We assemble your IKEA furniture in North Zealand — Hillerød, Helsingør, Hørsholm and surroundings. Fixed price incl. VAT.", area: "3000–3670 North Zealand" },
  },
};

export default function SeoCityPage({ city }) {
  const { t, lang } = useLang();
  const data = CITY[city][lang];

  useEffect(() => {
    document.title = `${data.title} | Belov Multiservice`;
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); return m;
    })();
    meta.content = data.desc;
  }, [lang, data]);

  return (
    <div data-testid={`seo-${city}-page`}>
      <section className="bg-[#F4F1EA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-semibold text-[#1E3A2F] bg-white px-3 py-1.5 rounded-full border border-stone-200">
            <MapPin className="w-3.5 h-3.5" /> {data.area}
          </span>
          <h1 className="mt-4 text-3xl sm:text-5xl font-display font-extrabold tracking-tight text-stone-900 max-w-3xl">{data.title}</h1>
          <p className="mt-4 text-lg text-stone-600 max-w-2xl">{data.desc}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/pax-montering" className="inline-flex items-center gap-2 rounded-full bg-[#1E3A2F] text-white px-6 py-3.5 font-bold hover:bg-[#162D24]" data-testid="seo-cta-btn">
              {t.common.getPrice} <ArrowRight className="w-4 h-4" />
            </Link>
            <div className="inline-flex items-center gap-2 text-sm text-stone-700 bg-white px-4 py-3.5 rounded-full border border-stone-200">
              <ShieldCheck className="w-4 h-4 text-emerald-600" /> {t.hero.point1}
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="max-w-2xl mb-8">
          <h2 className="text-2xl sm:text-3xl font-display font-bold tracking-tight text-stone-900">{t.pax.heroTitle} — {data.name}</h2>
          <p className="mt-3 text-stone-600">{t.pax.heroSubtitle}</p>
        </div>
        <PaxCalculator />
      </section>
    </div>
  );
}
